export default {
  status: null,
  timer: null
};
